/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { lazy, FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { AuthPage } from '../modules/auth'
import { App } from '../App'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
// const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const agentSlice = useSelector((state: RootState) => state.agent)

  const SingleSignOnPage = lazy(() => import('../pages/SingleSignOnPage'))

  return (
    <BrowserRouter basename={'/'}>
      <Routes>
        <Route element={<App />}>
          <Route path="/signon/:key/:page" element={<SingleSignOnPage />} />
          <Route path="/signon/:platform/:key/:page" element={<SingleSignOnPage />} />
          {agentSlice._id ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
            </>
          ) : (
            <>
              <Route path='/' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
